import { render, staticRenderFns } from "./BannerComp.vue?vue&type=template&id=595acd48&"
var script = {}
import style0 from "./BannerComp.vue?vue&type=style&index=0&id=595acd48&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports